import React, { FC } from "react";
import { Button } from "../../Form/Button";
import "./TruckingResourcesNotAllocated.css";
import { CloseButton } from "../../Form/CloseButton";

interface ITruckingResourcesNotAllocatedProps {
  onConfirm?(): void;
  onClose?(): void;
  onCancel?(): void;
  message: string;
  title: string;
  onConfirmButtonText?: string;
  yesNoButtons: boolean;
}

export const TruckingResourcesNotAllocated: FC<ITruckingResourcesNotAllocatedProps> = (props) => {
  return (
    <div>
      <div className="TruckingResourcesNotAllocated More_Resources">
        <div className="New_Crew_Title">
          <div className="Wrap">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="graniterock" />
            <div className="Title">{props.title}</div>
          </div>
          <CloseButton onClick={props.onClose} />
        </div>
        <div className="TruckingResourcesNotAllocated_Body">
          <div className="ErrorMessage">
            <div className="ErrorText">
              {props.message}
            </div>
          </div>
          {
            props.yesNoButtons === true
              ? <div className="ErrorActionHolder">
                <Button
                  onClick={() => { props.onConfirm?.(); props.onClose?.(); }}
                  title="Yes"
                  type="button"
                  className="Button"
                />
                <Button
                  onClick={() => { props.onCancel?.(); props.onClose?.() }}
                  title="No"
                  type="button"
                  className="Button"
                />
              </div>
              : <div>
                <Button
                  onClick={() => { props.onClose?.() }}
                  title="Ok"
                  type="button"
                  className="Button"
                />
              </div>
          }
        </div>
      </div>
    </div>
  );
}